/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const FacilityDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.FacilityDetailsPage,
);
